import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import AboutView from "@/views/AboutView.vue";
import AboutUsView from "@/views/AboutUsView.vue";
import ServicesView from "@/views/ServicesView.vue";
import PortafiloView from "@/views/PortafiloView.vue";
import ContactView from "@/views/ContactView.vue";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Home | PixYz' }
  },
  {
    path: '/workLine',
    name: 'WorkLine',
    component: AboutView,
    meta: { title: 'Work Line | PixYz' }
  },
  {
    path: "/aboutUs",
    name: "About Us",
    component: AboutUsView,
    meta: { title: 'About Us | PixYz' }
  },
  {
    path: "/services",
    name: "Services",
    component: ServicesView,
    meta: { title: 'Services | PixYz' }
  },
  {
    path: "/portafilo",
    name: "Portafilo",
    component: PortafiloView,
    meta: { title: 'Portafilo | PixYz' }
  },
  {
    path : "/contact",
    name: "Contact",
    component: ContactView,
    meta: { title: 'Contact | PixYz' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  Vue.nextTick(() => {
      document.title = to.meta.title || 'test';
  });
});
export default router
